export default "__VITE_ASSET__DAn1qvu0__"